
import Injection = EECore.Injection;
import CorporateSearchModel from "../entities/corporateSearch/corporateSearchModel";

@Injection.injectableClass("CorporateSearchService")
export default class CorporateSearchService {

  @Injection.injectableProperty("CorporateSearchService", EECore.Registrations.HTTP_CLIENT)
  private httpClient: EECore.HttpClient;

  private cachedHttpRequest: EECore.Promise<CorporateSearchModel, string>;

  constructor(httpClient: EECore.HttpClient) {
    this.httpClient = httpClient;
  }

  getContracts(clientNo: string, companyCode: string) {
    if (this.cachedHttpRequest == null) {

      let url = "/wemwpn45/api/contract/clientcontracts";
      if (clientNo !== null && companyCode !== null) url += `?clientNo=${clientNo}&companyCode=${companyCode}`;

      this.cachedHttpRequest = this.httpClient.get<CorporateSearchModel>(url, true);
    }
    return this.cachedHttpRequest;
  }
}